import {
  loginApi,
  logOutApi,
  ILoginParams,
  forgotPasswordApi,
  resetPasswordApi,
  // sendOTPApi,
} from "services/session.js";
import validator from "validator";

import {
  navigateToIndex,
  navigateToResetPassOTPScreen,
  navigateToResetPasswordViaMobile,
  navigateToSignIn,
} from "app/navigation.js";
import { getErrorObject, errorToast, successToast } from "utilities/utils";
import { appRoutesConst, navigateTo } from "../app/navigation";
import { message } from "antd";
import { updatePlayerID } from "../services/session";
import { verifyObject } from "../utilities/utils";
import store from "app/store";

export const types = {
  LOGIN_REQUEST: "session/LOGIN_REQUEST",
  LOGIN_SUCCESS: "session/LOGIN_SUCCESS",
  LOGIN_FAILURE: "session/LOGIN_FAILURE",
  SEND_OTP_REQUEST: "session/SEND_OTP_REQUEST",
  SEND_OTP_SUCCESS: "session/SEND_OTP_SUCCESS",
  SEND_OTP_FAILURE: "session/SEND_OTP_FAILURE",
  VERIFY_OTP_REQUEST: "session/VERIFY_OTP_REQUEST",
  VERIFY_OTP_SUCCESS: "session/VERIFY_OTP_SUCCESS",
  VERIFY_OTP_FAILURE: "session/VERIFY_OTP_FAILURE",
  RESET_PASS_REQUEST: "session/RESET_PASS_REQUEST",
  RESET_PASS_SUCCESS: "session/RESET_PASS_SUCCESS",
  RESET_PASS_FAILURE: "session/RESET_PASS_FAILURE",
  RESET_FORM_STATE: "session/RESET_FORM_STATE",
  FORGOT_PASSWORD_REQUEST: "session/ FORGOT_PASSWORD_REQUEST",
  FORGOT_PASSWORD_SUCCESS: "session/ FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE: "session/ FORGOT_PASSWORD_FAILURE",
  LOG_OUT: "session/LOG_OUT",
};

export const login = (data: ILoginParams, navigate, is_signin) => {
  return async (dispatch) => {
    dispatch({ type: types.LOGIN_REQUEST });

    try {
      let response = await loginApi(data);
      const user = response.data.data;
      let tokenparams = {};
      if (user.auth_token) {
        tokenparams = { token: user.auth_token };
      }

      // if (!user.password_expired) {
      //   localStorage.setItem("otp-phone", JSON.stringify(user.phone));
      //   if (user.phone) {
      //     dispatch({
      //       type: types.LOGIN_SUCCESS,
      //       payload: { user, ...tokenparams },
      //     });
      //     successToast({ content: "OTP sent successfully" });
      //     // await data.props.history.push(`${appRoutesConst.verfifyotp}`);
      //   }
      // } else {
      //   let tokenparams = { reset_pass_token: "" };
      //   if (user.auth_token) {
      //     tokenparams = { reset_pass_token: user.auth_token };
      //   }

      // }

      dispatch({
        type: types.LOGIN_SUCCESS,
        payload: { ...tokenparams, user },
      });
      successToast({
        content: verifyObject(response, "data.message", "Success"),
      });
      // await props.history.push(`${appRoutesConst.index}`);
      if (is_signin) {
        store.dispatch({
          type: "IS_SIGNIN",
          payload: true,
        });
      } else {
        store.dispatch({
          type: "IS_SIGNIN",
          payload: false,
        });
      }

      navigate(`${appRoutesConst.index}`);

      // dispatch(navigateToCustomerSelection());
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({ type: types.LOGIN_FAILURE, payload: { error: message } });
      errorToast({ content: message });

      console.log("Navigate ", navigate);
    }
  };
};

export const navigateToResetPassword = (token) => {
  return (dispatch) => {
    dispatch(navigateToResetPasswordViaMobile(token));
  };
};
export const navigateToindexFromToken = (token) => {
  return (dispatch) => {
    dispatch(navigateToIndex());
  };
};
export const navigateToCustomerSelectionViaOTP = (response) => {
  return async (dispatch) => {
    dispatch({ type: types.LOGIN_REQUEST });
    try {
      // response.role = role;
      const user = response.data.data.user;
      const token = user.auth_token;
      dispatch({ type: types.LOGIN_SUCCESS, payload: { user, token } });
      if (user.password_expiry_due) {
        message.warning(
          `Your password will expire in ${user.days_left_for_current_password} day/s, please change before it gets expired`,
          7
        );
      }
      var OneSignal = window.OneSignal || [];
      console.log("OneSignal==>", await OneSignal.getUserId());

      // successToast({ content: "Login success" });
      let player_id = localStorage.getItem("player_id");
      if (!player_id) {
        player_id = await OneSignal.getUserId();
      }
      if (player_id) {
        updatePlayerID({ player_id: player_id });
      }
      await console.log("Local Player ID", player_id);
      dispatch(navigateTo(`${appRoutesConst.dashboard}`));
    } catch (error) {
      console.log("ERROR OS", error);
      const { message } = getErrorObject(error);
      dispatch({ type: types.LOGIN_FAILURE, payload: { error: message } });
      errorToast({ content: message });
    }
  };
};
export const forgotPassword = (data) => {
  console.log("clicked");
  return async (dispatch) => {
    dispatch({ type: types.FORGOT_PASSWORD_REQUEST });
    try {
      const response = await forgotPasswordApi({
        email: data.email,
        role: "doctor",
      });
      dispatch({
        type: types.FORGOT_PASSWORD_SUCCESS,
        payload: { data: response.data.data },
      });
      let isEmail = true;
      if (validator.isEmail(data.email)) {
        isEmail = true;
      } else {
        isEmail = false;
      }
      if (response.data && response.data.message) {
        successToast({
          content: response.data.message,
        });
      }
      if (isEmail) {
        dispatch(navigateToIndex());
      } else {
        let phone = data.email;
        // let newphone = phone.replace("+91", "");
        // newphone = "+91" + newphone;
        localStorage.setItem("otp-phone", JSON.stringify(phone));
        dispatch(navigateToResetPassOTPScreen());
      }
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.FORGOT_PASSWORD_FAILURE,
        payload: { error: message },
      });
      errorToast({ content: message });
    }
  };
};

export const resetPassword = (data: IResetPasswordParams) => {
  return async (dispatch) => {
    dispatch({ type: types.RESET_PASS_REQUEST });
    try {
      const response = await resetPasswordApi(data);
      dispatch({
        type: types.RESET_PASS_SUCCESS,
        payload: { data },
      });
      successToast({
        content: response.data.message,
      });
      dispatch(navigateToIndex());
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.RESET_PASS_FAILURE,
        payload: { error: message },
      });
      errorToast({ content: message });
    }
  };
};
export const navigateToSignInPath = (token) => {
  return (dispatch) => {
    dispatch(navigateToSignIn());
  };
};
export const logOut = (navigate) => {
  return (dispatch) => {
    logOutApi();
    dispatch({
      type: types.LOG_OUT,
    });
    // localStorage.removeItem("player_id");

    navigate(appRoutesConst.index);
    dispatch({ type: "CLEAR_LOCAL_STATE" });
    // localStorage.clear();
  };
};

export const resetFormState = () => {
  return (dispatch) => {
    dispatch({
      type: types.RESET_FORM_STATE,
    });
  };
};
